module.exports = __webpack_public_path__ + "static/media/botticino.5d94b5c9.png";